export const isEngineeringFile = (fileName) => {
    return fileName.toLowerCase().indexOf('engineering') !== -1;
}